import React, { useState } from 'react';
import { Footer } from '../../Components/Footer';
import HeroContainer from '../../Components/ui/hero-container';
import Button from '../../Components/ui/button/Button';
import FeatureInfoCard from '../../Components/FeatureInfoCard';
import { TutorCrmData } from './data/TutorCrmData';
import HeaderAlt from '../../Components/HeaderAlt';
import CustomModal from '../../Components/CustomModal';
import ApplyAsTutorPopup from '../../Components/apply-as-tutor/ApplyAsTutorPopup';

const TutorCrm = () => {
  const [showSignupModal, setShowSignupModal] = useState(false);
  return (
    <>
      <HeaderAlt />
      <div className="flex-container relative">
        <HeroContainer className="flex pt-5  md:pt-8">
          <div className="container flex flex-col gap-6 !px-6 md:flex-row md:justify-between md:gap-20 md:!px-0">
            <div className="max-w-[574px] space-y-4 !pt-2 text-left md:space-y-6">
              <p className="!mb-4 text-center text-base font-medium uppercase tracking-[1.28px] text-[#66CDCC] md:text-left">
                Our Platform
              </p>
              <h1 className="fredokaOne w-full text-center text-[40px] font-normal  leading-tight tracking-[-0.8px] text-white md:text-left md:!text-[56px] md:tracking-[-1.12px]">
                Smarter Tutoring,
                <br /> Simplified
              </h1>
              <p className="fredoka max-w-2xl text-center text-[18px] font-medium leading-[144.44%] tracking-[-0.18px] text-[#678285] md:text-left md:text-[22px] md:leading-[32px] md:tracking-[-0.22px]">
                Manage your students, sessions, and study materials effortlessly with our AI-powered
                Tutor CRM. Organize schedules, track progress, and enhance student engagement—all in
                one place.
              </p>
              <div className="w-full pt-2 md:w-fit">
                <Button onClick={() => setShowSignupModal(true)} label={'Get Started'} />
              </div>
            </div>
            <div className="mt-6 flex-1 md:mt-0">
              <img src="/images/tutor-crm/tutor-crm-hero.png" alt="hero-img" className="block" />
            </div>
          </div>
        </HeroContainer>

        <div className="container !mt-5 flex flex-col gap-4  md:!mt-16 ">
          {TutorCrmData.map((data, index) => (
            <FeatureInfoCard key={index} data={data} />
          ))}
        </div>

        <div className="container !my-14">
          <div className="container relative !my-14 flex flex-col justify-between rounded-[56px] bg-[#66CDCC] !p-5 px-4 lg:!h-[500px] lg:flex-row lg:!p-16">
            <div className="mx-auto max-w-lg space-y-4 lg:mx-0">
              <h1 className="fredokaOne text-center text-[32px] font-normal leading-tight tracking-[-0.64px] text-[#012E33] md:tracking-[-0.8px] lg:text-left lg:text-[40px]">
                Turn your expertise into Income by teaching students
              </h1>
              <button
                onClick={() => setShowSignupModal(true)}
                className="w-full rounded-[16px] bg-white px-6 py-2 font-semibold lg:w-fit"
              >
                Apply as Tutor
              </button>
              <div className="mx-auto max-w-sm lg:mx-0">
                <img
                  src="/images/apply-as-tutor/hurry_up_tutor.png"
                  className="hidden lg:ml-12 lg:block"
                  alt="hurryup"
                />
                <img
                  src="/images/apply-as-tutor/hurry-up-tutor2.png"
                  alt="hurryup"
                  className="block lg:hidden"
                />
              </div>
            </div>
            <div className="bottom-0 right-0 m-auto flex-1 lg:absolute lg:-top-20 lg:m-0 lg:max-w-lg">
              <img
                src="/images/apply-as-tutor/apply-as-tutor-img1.png"
                alt=""
                className="hidden lg:block"
              />
              <img
                src="/images/apply-as-tutor/tutors-small.png"
                alt=""
                className="block lg:hidden"
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <CustomModal
        className="max-w-[480px]"
        isOpen={showSignupModal}
        onClose={() => setShowSignupModal(false)}
      >
        <ApplyAsTutorPopup />
      </CustomModal>
    </>
  );
};

export default TutorCrm;
